import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import PayOrder from '../views/PayOrder.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '中国民族民间工艺美术家协会'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '中国民族民间工艺美术家协会-注册'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Register,
    meta: {
      title: '中国民族民间工艺美术家协会-注册'
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: PayOrder,
    meta: {
      title: '中国民族民间工艺美术家协会-支付'
    }
  },
  {
    path: '/selfPay',
    name: 'selfPay',
    component: PayOrder,
    meta: {
      title: '中国民族民间工艺美术家协会-支付'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
